import { getWindow } from './helpers';

const reload = () => {
  const win = getWindow();
  if (win) {
    win.location.reload();
  }
};

export default reload;
